module.exports = __webpack_public_path__ + "static/media/2_CAM-BUV-050 Induction PFP_Graph.5e13990b.png";